<template>
  <div class="operation-log">
    <div class="toolbar">
      <h3>操作日志</h3>
      <el-button size="small" @click="loadLogs">刷新</el-button>
    </div>
    <el-table v-loading="loading" :data="logs" stripe>
      <el-table-column prop="createdAt" label="时间" min-width="180">
        <template slot-scope="{ row }">
          {{ formatTime(row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作类型" width="180">
        <template slot-scope="{ row }">
          {{ actionLabel(row.action) }}
        </template>
      </el-table-column>
      <el-table-column prop="targetType" label="目标类型" width="140" />
      <el-table-column prop="targetId" label="目标 ID" min-width="160" />
      <el-table-column prop="operator" label="操作人" width="100" />
      <el-table-column prop="detail" label="详情" min-width="240" show-overflow-tooltip />
    </el-table>
    <div class="pager">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="page + 1"
        :page-size="size"
        :total="total"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { fetchOperationLogs } from '../api/admin';

const ACTION_LABELS = {
  SEGMENT_TASK_RETRY: '重跑切片任务',
  SEGMENT_TASK_DELETE: '删除切片任务',
  CONFIG_UPDATE: '更新系统配置',
  USER_UPDATE: '更新用户',
  QUOTA_PLAN_UPDATE: '更新会员配额',
  IP_BLOCK: '封禁 IP',
  IP_UNBLOCK: '解封 IP',
};

export default {
  name: 'OperationLog',
  data() {
    return {
      loading: false,
      logs: [],
      page: 0,
      size: 20,
      total: 0,
    };
  },
  mounted() {
    this.loadLogs();
  },
  methods: {
    async loadLogs() {
      this.loading = true;
      try {
        const data = await fetchOperationLogs(this.page, this.size);
        this.logs = data.items || [];
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error(e.message || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    onPageChange(currentPage) {
      this.page = currentPage - 1;
      this.loadLogs();
    },
    actionLabel(action) {
      return ACTION_LABELS[action] || action;
    },
    formatTime(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString('zh-CN', { hour12: false });
    },
  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.toolbar h3 {
  margin: 0;
}
.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
